const faqs = [
  {
    q: '韩漫之家是什么？',
    a: '韩漫之家是一个专注于韩漫下载安装与离线阅读的一站式服务平台。我们为用户提供最新韩漫APK下载、免费韩漫资源汇总以及详细的安装使用教程，帮助你轻松实现在手机上离线畅享韩漫全集。',
  },
  {
    q: '如何下载安装韩漫APK？',
    a: '访问韩漫之家网站，在APP下载专区选择适合你手机系统的韩漫APK版本，点击下载后按照安装向导完成安装即可。安卓用户需在设置中开启「允许安装未知来源应用」，iOS用户可通过TestFlight或企业签名方式安装。',
  },
  {
    q: '离线韩漫需要付费吗？',
    a: '韩漫之家推荐的韩漫APP大部分基础功能免费使用，支持免费离线下载阅读。部分平台可能需要VIP会员才能解锁全部作品或高清画质，但我们会在推荐时标注清楚，并优先推荐免费资源丰富的应用。',
  },
  {
    q: '离线下载的韩漫保存在哪里？',
    a: '离线下载的韩漫文件通常保存在APP指定的本地存储目录中，可在APP内直接管理。下载前建议确保手机有足够的存储空间，一般一话漫画占用5-15MB，一部完整作品约占用100-500MB。',
  },
  {
    q: '韩漫之家推荐的APP安全吗？',
    a: '我们严格筛选推荐的韩漫APP，优先选择有正规运营资质、用户评价良好的应用。所有推荐的APK均经过基础安全检测。同时建议用户尽量从官方渠道下载，安装前使用手机安全软件扫描确认。',
  },
];

export default function Faq() {
  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            常见问答
          </h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">
            关于韩漫下载与使用的常见问题解答
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <details
              key={idx}
              className="group bg-background-50 rounded-xl border border-background-200/60 overflow-hidden"
              open={idx === 0}
            >
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {faq.q}
                </h3>
                <span className="w-6 h-6 flex items-center justify-center shrink-0 text-foreground-400 group-open:hidden">
                  <i className="ri-add-line"></i>
                </span>
                <span className="w-6 h-6 flex items-center justify-center shrink-0 text-foreground-400 hidden group-open:flex">
                  <i className="ri-subtract-line"></i>
                </span>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}